export const MIN_TRIM_SECONDS = 0.1;
const FULL_RANGE_TOLERANCE = 0.05;

export const clampTrimStart = (value: number, end: number): number =>
  Math.min(Math.max(value, 0), Math.max(0, end - MIN_TRIM_SECONDS));

export const clampTrimEnd = (
  value: number,
  start: number,
  duration: number
): number =>
  Math.max(
    Math.min(value, duration),
    Math.min(duration, start + MIN_TRIM_SECONDS)
  );

export const isTrimRangeValid = (
  start: number,
  end: number,
  duration: number
): boolean => duration <= 0 || end - start >= MIN_TRIM_SECONDS;

export const isTrimTimeWithinRange = (
  time: number,
  start: number,
  end: number
): boolean => time >= start && time < end;

export const isFullTrimRange = (
  start: number,
  end: number,
  duration: number
): boolean =>
  duration <= 0 ||
  (start <= FULL_RANGE_TOLERANCE && end >= duration - FULL_RANGE_TOLERANCE);
